import { useTrackingManager } from '../../../tracking/use-tracking-manager';
import { formatOwnership } from '../../../tracking/tracking-helper';
import { Vehicle } from '@esportal/portal-service';
import { ServiceGroupType } from '../models/services-layer-types';
import { useCallback } from 'react';

export const useMyServicesTracker = () => {
	const sectionName = 'My Services';
	const trackingManager = useTrackingManager();

	const trackSelectedVehicleChange = (selectedVehicle: Vehicle) => {
		const contentIdValue = `${sectionName} - Seleccionar vehículo`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(Array(selectedVehicle)) },
		);
	};

	const trackMyServicesAccordion = (selectedVehicle: Vehicle, accordionId: ServiceGroupType, isOpen: boolean) => {
		const contentIdValue = `${sectionName} - ${accordionId}`;
		if (isOpen) {
			trackingManager.trackClubVWAccordionClose(
				contentIdValue,
				{ groupItemState: 'closed' },
				{ vehicle: formatOwnership(Array(selectedVehicle)) },
				{ contentId: contentIdValue },
			);
		} else {
			trackingManager.trackClubVWAccordionOpen(
				contentIdValue,
				{ groupItemState: 'open' },
				{ vehicle: formatOwnership(Array(selectedVehicle)) },
				{ contentId: contentIdValue },
			);
		}
	};

	const trackOpenMyServicesLayerClick = (
		selectedVehicle: Vehicle,
		layerId: ServiceGroupType,
		layerTitle: string,
		ctaLabel: string,
	) => {
		const contentIdValue = `${ctaLabel} - ${sectionName} - Open Layer - ${layerId} - ${layerTitle}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(Array(selectedVehicle)) },
		);
	};

	const trackLoadMyServicesLayer = useCallback(
		(selectedVehicle: Vehicle, layerId: ServiceGroupType, layerTitle: string) => {
			const contentIdValue = `${sectionName} - ${layerId} - ${layerTitle}`;

			trackingManager.trackClubVWLayerLoad(
				{ contentId: contentIdValue },
				{ vehicle: formatOwnership(Array(selectedVehicle)) },
			);
		},
		[trackingManager],
	);

	const trackCloseMyServicesLayerClick = useCallback(
		(layerId: ServiceGroupType, layerTitle: string) => {
			const contentIdValue = `${sectionName} - ${layerId} - ${layerTitle}`;
			trackingManager.trackClubVWLayerCloseClick(contentIdValue, { contentId: contentIdValue });
		},
		[trackingManager],
	);

	const trackMyServicesLayerCtaClick = (
		selectedVehicle: Vehicle,
		layerId: ServiceGroupType,
		layerTitle: string,
		ctaLabel: string,
	) => {
		const contentIdValue = `${ctaLabel} - ${sectionName} - ${layerId} - ${layerTitle}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(Array(selectedVehicle)) },
		);
	};

	const trackMyServicesPideCitaCtaClick = (selectedVehicle: Vehicle, ctaLabel?: string) => {
		const contentIdValue = `${ctaLabel ?? 'Pide cita en el taller'} - ${sectionName}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(Array(selectedVehicle)) },
		);
	};

	return {
		trackSelectedVehicleChange,
		trackMyServicesAccordion,
		trackOpenMyServicesLayerClick,
		trackLoadMyServicesLayer,
		trackCloseMyServicesLayerClick,
		trackMyServicesLayerCtaClick,
		trackMyServicesPideCitaCtaClick,
	};
};
